import * as React from "react";

interface IListHeaderProps {
  additionalRows?: React.ReactNode[];
  actions?: React.ReactNode[];
}

const ListHeader: React.FunctionComponent<IListHeaderProps> = (props) => {
  return (
    <div className="list-head">
      {((props.actions != null && props.actions?.length > 0) ||
        props.children) && (
        <div className="px-3 py-2">
          <div className="row align-items-center py-1">
            <div className="col-lg-4 col-md-4 col-12 pl-md-0">
              <div>{props.children}</div>
            </div>
            {props.actions != null && props.actions?.length > 0 && (
              <div className="col-lg-8 col-md-8 col-12 pr-md-0">
                <div className="row m-0 align-items-center justify-content-end">
                  {props.actions?.map((action, index) => {
                    return (
                      <div className="col-auto d-flex position-static custom-date-range" key={index}>
                        {action}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {props.additionalRows}
    </div>
  );
};

export default ListHeader;
